import React from "react";
import { motion } from "framer-motion";

export function SectionEyebrow({ children, testId }) {
    return (
        <div
            className="inline-flex items-center gap-2 text-[11px] md:text-xs uppercase tracking-[0.22em] text-brand-green"
            data-testid={testId}
        >
            <span className="h-px w-6 bg-gradient-to-r from-brand-blue to-brand-green" />
            {children}
        </div>
    );
}

export function SectionHeading({ eyebrow, title, subtitle, align = "left", testId }) {
    return (
        <div
            className={`flex flex-col gap-5 ${align === "center" ? "items-center text-center" : "items-start"} max-w-3xl`}
            data-testid={testId}
        >
            {eyebrow && <SectionEyebrow>{eyebrow}</SectionEyebrow>}
            <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, ease: [0.2, 0.7, 0.2, 1] }}
                className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.02]"
            >
                {title}
            </motion.h2>
            {subtitle && (
                <p className="text-zinc-400 text-[16px] md:text-lg leading-relaxed max-w-2xl">
                    {subtitle}
                </p>
            )}
        </div>
    );
}
